<template>
  <v-row>
    <v-col cols="12">
      <v-fade-transition mode="out-in">
        <div v-if="loading.item">
          <v-card flat color="transparent" class="pb-6">
            <v-skeleton-loader type="heading"></v-skeleton-loader>
          </v-card>

          <v-card flat outlined color="transparent" class="pb-10">
            <v-card-text class="pa-0">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </div>

        <v-card v-else tile flat color="transparent">
          <v-card-title class="px-0 pt-0">
            <v-row align="center">
              <v-col>
                <div class="headline">Task</div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pa-0">
            <v-card tile flat outlined>
              <v-card-title class="py-0 px-1">
                <v-container fluid>
                  <v-row>
                    <v-col class="pb-0" cols="9">
                      <span class="subtitle-1">Project: </span>
                      <router-link
                        class="subtitle-1"
                        :to="{
                          name: 'project',
                          params: { project_id: task.task_list.project.id }
                        }"
                      >
                        {{ task.task_list.project.name }}
                      </router-link>

                      <span class="subtitle-1"> - Task list: </span>
                      <router-link
                        class="subtitle-1"
                        :to="{
                          name: 'tasklist',
                          params: { task_list_id: task.task_list.id }
                        }"
                      >
                        {{ task.task_list.title }}
                      </router-link>
                    </v-col>

                    <v-col align="right" class="pb-0" cols="3">
                      <div class="subtitle-1">{{ task.created_at }}</div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pt-0" cols="9">
                      <task-checkbox :task="task">{{
                        task.title
                      }}</task-checkbox>
                    </v-col>

                    <v-col align="right" class="pt-0" cols="3">
                      <form-modal
                        btnText="Edit"
                        modalTitle="Edit task"
                        outlined
                        small
                        tile
                      >
                        <template #form="{ cancel }">
                          <task-edit-form @cancel="cancel" :task="task" />
                        </template>
                      </form-modal>

                      <v-btn
                        class="ml-2"
                        outlined
                        small
                        tile
                        @click="confirmDelete(task.id)"
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pt-0">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>

              <v-card-text>
                <v-row justify="center">
                  <v-col cols="8">
                    <discussions-card
                      :discussions="discussions"
                      :loading="discussionsLoading"
                    />
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col cols="8">
                    <discussion-create-edit-form
                      :discussableId="task.id"
                      storeModuleName="tasks"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DiscussionsCard from '@/components/discussions/DiscussionsCard'
import { alertConfirm } from '@/utilities/sweetalert'
import FormModal from '@/components/common/FormModal'
import TaskEditForm from '@/components/tasks/common/TaskEditForm'
import DiscussionCreateEditForm from '@/components/discussions/DiscussionCreateEditForm'
import TaskCheckbox from '@/components/tasks/common/TaskCheckbox'

export default {
  name: 'Task',
  components: {
    DiscussionsCard,
    FormModal,
    TaskEditForm,
    DiscussionCreateEditForm,
    TaskCheckbox
  },
  data: () => ({
    intervalId: null,
    discussionsLoading: true
  }),
  computed: {
    ...mapGetters('tasks', ['loading', 'task', 'discussions']),
    taskId() {
      return this.$route.params.task_id
    }
  },
  methods: {
    ...mapActions('tasks', ['fetchTask', 'fetchDiscussions', 'deleteTask']),
    confirmDelete(id) {
      const projectId = this.task.task_list.project.id

      alertConfirm(
        {
          title: 'Are you sure you want to delete this task?',
          text: 'All tasks under this will be deleted as well.'
        },
        () =>
          this.deleteTask(id).then(() => {
            this.$router.push({
              name: 'project',
              params: { project_id: projectId }
            })
          })
      )
    }
  },
  created() {
    this.fetchTask(this.taskId)

    this.discussionsLoading = true // Loading only initiates once
    this.fetchDiscussions(this.taskId).then(() => {
      this.discussionsLoading = false
    })

    this.intervalId = setInterval(() => {
      this.fetchDiscussions(this.taskId)
    }, 5000) // TODO = change interval to realtime
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  }
}
</script>
